import type { Service, Badge } from '@eventcatalog/sdk';
import type { CompassConfig } from './compass';

type ServiceOptions = {
  id?: string;
  path: string;
  version?: string;
};

export type ApiConfig = {
  cloudId: string;
  apiToken: string;
  email: string;
  baseUrl: string;
  typeFilter?: string[];
};

export type StructuredLink = {
  url: string;
  title: string;
  type: string;
  icon: string;
  rawType: string;
};

export type MarkdownTemplateFn = (config: CompassConfig, dependencies: ResolvedDependency[], links?: StructuredLink[]) => string;

export type ServiceIdStrategyFn = (config: CompassConfig) => string;
export type ServiceIdStrategy = 'name' | 'compass-id' | ServiceIdStrategyFn;

// Configuration the users give your catalog
export type GeneratorProps = {
  // YAML mode (existing)
  services?: ServiceOptions[];
  // API mode (new)
  api?: ApiConfig;
  compassUrl: string;
  domain?: DomainOption;
  debug?: boolean;
  overrideExisting?: boolean;
  typeFilter?: string[];
  nameFilter?: string[];
  nameMapping?: Record<string, string>;
  markdownTemplate?: MarkdownTemplateFn;
  format?: 'md' | 'mdx';
  serviceIdStrategy?: ServiceIdStrategy;
  dryRun?: boolean;
  defaultVersion?: string;
  badges?: boolean;
  incremental?: boolean;
};

export type DomainSpec = {
  id: string;
  name: string;
  version: string;
};

export type DomainMapping = {
  from: 'label' | 'customField';
  key?: string;
  mapping: Record<string, DomainSpec>;
  fallback?: DomainSpec | 'skip';
};

export type DomainOption = DomainSpec | DomainMapping;

export type ResolvedDependency = {
  id: string;
  name: string;
};

// Re-export SDK types for convenience
export type { Service, Badge };
